module.exports = __webpack_public_path__ + "static/media/bg.61437ae6.png";